import PreloadedTimeSliderView from "../../../ui/PreloadedTimeSliderView";


/** Clase que controla el comportamiento visual del TimeSlider del radar con doble animación (tradicional y con precarga) */
class RadarTimeSliderView extends PreloadedTimeSliderView{

    /**
     * Elemento HTML que contiene el botón de play de la animación con precarga
     * @protected
     */
    protected readonly buttonMoviePlay: HTMLElement | null = null;
    /**
     * Elemento HTML que contiene el botón de stop de la animación con precarga
     * @protected
     */
    protected readonly buttonMovieStop: HTMLElement | null = null;

    protected _handleStartMovieAnimation: ((loopSteps: number, futuresteps: boolean) => any) |undefined |null = null;

    protected _handleStopMovieAnimation: (() => any) |undefined |null = null;

    protected _handleSelectFutureOverlay: (() => any) |undefined |null = null;

    protected _handleGetFutureTranslation: (() => any) |undefined |null = null;

    private movieplaying: boolean = false;


    /**
     * Crea e inicializa un objeto
     *
     * @param timeSliderElement
     */
    constructor( timeSliderElement:Element ) {
        super(timeSliderElement);

        let slider:Element|null = timeSliderElement;

        if (slider) {
            this.buttonMoviePlay = slider.querySelector("#buttonMoviePlay");
            this.buttonMovieStop = slider.querySelector("#buttonMovieStop");

            // Función que se ejecuta al hacer click sobre el botón Play
            this.buttonMoviePlay?.addEventListener("click", () =>{
                if ( ! this.movieplaying && this.redrawFinished )
                    this.startMoviePlaying(0, true);
            });

            // Función que se ejecuta al hacer click sobre el botón Stop
            this.buttonMovieStop?.addEventListener("click", (e:any) =>{
                if (this.movieplaying) {
                    /* ...lo detenemos */
                    this.stopMoviePlaying();
                }
            });

            document.addEventListener("overlayMenuOpened", this.stopMoviePlaying.bind(this));

        }

    }

    /**
     * Deshabilita el uso del TimeSlider
     */
    override disableSlider() {
        super.disableSlider();
        if (this.buttonMoviePlay)
            this.buttonMoviePlay.classList.add("disabled");
    }

    /**
     * Habilita el uso del TimeSlider
     */
    override enableSlider() {
        super.enableSlider();
        if (this.buttonMoviePlay && ! this.movieplaying && this.nslot >= 0)
            this.buttonMoviePlay.classList.remove("disabled");
    }

    /**
     * Inicia la animación con precarga
     *
     * @param loopSteps
     * @param futuresteps
     */
    startMoviePlaying(loopSteps:number, futuresteps: boolean = true){
        if (!this.movieplaying && this._handleStartMovieAnimation) {
            this.slider?.classList.remove('open');
            this.movieplaying = true;
            this._handleStartMovieAnimation(loopSteps, futuresteps);
        }
    }

    /**
     * Detiene la reproducción con precarga
     */
    stopMoviePlaying(){
        if (this.movieplaying && this._handleStopMovieAnimation) {
            this.movieplaying = false;
            this._handleStopMovieAnimation();
        }
    }

    override disableButtonPlay(){
        super.disableButtonPlay();
        this.buttonMoviePlay?.classList.add("disabled");
    }

    override enableButtonPlay(){
        super.enableButtonPlay()
        this.buttonMoviePlay?.classList.remove("disabled");
    }


    // /**
    //  * Bloquea el timeslider para que el usuario no pueda usarlo
    //  */
    // override block(){
    //     super.block();
    //     if (this.buttonMoviePlay)
    //          this.buttonMoviePlay.classList.add("disabled");
    // }
    //
    // /**
    //  * Desbloquea el timeslider para que el usuario no pueda usarlo
    //  */
    // override unblock(){
    //     super.unblock();
    //     if (this.buttonMoviePlay)
    //         this.buttonMoviePlay.classList.remove("disabled");
    // }


    /**
     * Esconde el botón de play de animación con precarga y muestra el de stop
     */
    blockMovie(){

        if (this.buttonMoviePlay)
            this.buttonMoviePlay.style.display = 'none';

        if (this.buttonMovieStop)
            this.buttonMovieStop.style.display = 'inline';

        this.movieplaying = true;

    }

    /**
     * Esconde el botón de stop de animación con precarga y muestra el de stop
     */
    unBlockMovie(){

        if (this.buttonMoviePlay)
            this.buttonMoviePlay.style.display = 'inline';

        if (this.buttonMovieStop)
            this.buttonMovieStop.style.display = 'none';

        this.movieplaying = false;

    }


    /**
     * Escribe en la barra de precarga un texto que normalmente será en formato HH:MM y cambia el color si el timestamp es de nowcasting
     *
     * @param text Cadena de texto a escribir
     * @param forecast
     */
    override setProgressText(text: string, forecast: boolean = false){

        if (this.playbar) {
            const textspan = this.playbar.querySelector("#center_text");

            let color = "rgba(0, 60, 89, 0.36)";

            if(forecast)
                color = "rgba(0, 60, 89, 0.2)";

            this.playbar.style.background = color;

            if(textspan)
                textspan.innerHTML = text;

        }
    }

    /**
     * Actualiza los pasos de tiempo del TimeSlider
     *
     * @param timesteps Array que contiene los timesteps del TimeSlider. El campo text contiene el texto de la hora
     * @param tsnow timestep de la hora actual
     * @param selectedTs timestep de la hora seleccionada. El campo text contiene el texto del día de la semana
     */
    override updateTimeSteps ( timesteps : { ts: number, text: string, premium: boolean}[] ,
                      tsnow: { ts: number, text: string},
                      selectedTs: { ts: number, text: string}, domainurl: string = "") {


        // let day=-1;
        let newDayDiv = document.createElement("div");
        let nts=0, nslot=1, ntsPremium = 0;

        let hourSelector = this.hourSelector;
        let daySpan = this.daySpan;
        let changeDiv = false;
        let ul: HTMLUListElement | null = document.createElement("ul");

        let ulFirstDay = ul;

        // Borra todos los timesteps que hubiera
        // const isEmpty = this.hourSelector?.childElementCount === 0;
        while (this.hourSelector?.firstChild) {
            this.hourSelector.removeChild(this.hourSelector.firstChild);
        }

        newDayDiv.classList.add("day");
        hourSelector?.appendChild(newDayDiv);
        newDayDiv.appendChild(ul);

        this.nPremiumSlots = 0;

        for(let timestep of timesteps)
        {
            if (changeDiv ){
                    newDayDiv = document.createElement("div");
                    ul = document.createElement("ul");


                    newDayDiv.classList.add("day");
                    hourSelector?.appendChild(newDayDiv);
                    newDayDiv.appendChild(ul);
                    changeDiv = false;
            }

            // Elemento div para el timestep
            let newHourDiv = document.createElement("li");
            newHourDiv.classList.add("div-hour");
            if (! timestep.premium ) {
                // newHourDiv.id = "ts-" + nts;
                newHourDiv.dataset["nts"] = nts.toString();
                newHourDiv.style.cursor = 'pointer';
                newHourDiv.addEventListener("click", (e: Event) => {
                    if (this._handleSetTimestamp)
                        this._handleSetTimestamp(timestep.ts);
                });
            }
            else{
                // newHourDiv.id =  ntsPremium.toString();
                newHourDiv.dataset["nts"] = (-(ntsPremium + 1)).toString();
                newHourDiv.addEventListener("click", (e: Event) => {
                    if (newHourDiv.dataset["nts"]) {
                        const ntsPremium = parseInt(newHourDiv.dataset["nts"]);
                        this.changeSlot(ntsPremium);
                    }
                });
            }
            newHourDiv.style.cursor = 'pointer';


            // Si el timestep coincide con el timestep seleccionado se le añade
            // la clase de estilo "hour-activa"
            if (selectedTs.ts === timestep.ts){

                newHourDiv.classList.add("hour-activa");

                // Elemento seleccionado
                nslot=nts;

                // Se actualiza el texto del día
                if (daySpan)
                    daySpan.textContent=selectedTs.text;
            }

            ul?.appendChild(newHourDiv);
            // slider.liWidth= newHourDiv.clientWidth;

            // Texto del TimeStep
            const spanText = document.createElement("span");
            spanText.textContent = timestep.text;
            if (timestep.premium) {
                const img = document.createElement("img");
                // img.dataset["src"] = domainurl + "css/svgs/diamante_premium_white.svg";
                // img.classList.add("lazy-image")
                img.src = domainurl + "css/svgs/diamante_premium_white.svg";
                img.alt = "premium";
                img.width = 12;
                img.height = 12;
                newHourDiv.appendChild(img);

                newHourDiv.classList.add("premium");
                this.nPremiumSlots++;
            }

            // let hourText = document.createTextNode(timestep.text);
            newHourDiv.appendChild(spanText);

            // Si el timestep coincide con el de la hora actual
            if (tsnow.ts === timestep.ts){
                changeDiv = true;
                let divActiva=document.createElement("div");
                divActiva.classList.add("div-activa");

                divActiva.setAttribute("draggable", "true");
                newHourDiv.appendChild(divActiva);

                divActiva=document.createElement("div");
                divActiva.classList.add("li-activa");
                newHourDiv.appendChild(divActiva);

            }


            if (! timestep.premium) {
                if (nts === 0){
                    this.liWidth = newHourDiv.clientWidth;
                }
                nts++;
            }
            else {
                if (ntsPremium === 0){
                    this.liPremiumWidth = newHourDiv.clientWidth;
                }
                ntsPremium++;
            }
        }

        const liElements = hourSelector?.getElementsByTagName("li")
        if (liElements){
            for (let i = 0; i < liElements.length; i++){
                const nts = parseInt(liElements[i].dataset["nts"]?? "0");
                if (nts < 0)
                    liElements[i].dataset["nts"] = ((-nts - 1) - this.nPremiumSlots).toString();
            }
        }

        // Actualiza el elemento seleccionado
        this.nslot = nslot;

        // Establece el scroll correcto
        if (hourSelector) {
            hourSelector.scrollLeft = this.nPremiumSlots * this.liPremiumWidth + this.nslot * this.liWidth;
        }
        // Actualiza en número de pasos de tiempo
        this.nsteps = nts;

        // Elemento div para el timestep
        let buttonFuture = document.createElement("li");
        buttonFuture.classList.add("buttonfuture");

        if (this._handleGetFutureTranslation) {
            buttonFuture.innerHTML = this._handleGetFutureTranslation() + ' ';
        }

        buttonFuture.addEventListener("click", (e: Event) => {
            if (this._handleSelectFutureOverlay)
                this._handleSelectFutureOverlay();
        });


        ul?.appendChild(buttonFuture);


        if (buttonFuture.clientWidth > 80){
            const width = buttonFuture.clientWidth + 21;
            newDayDiv.style.paddingRight = `calc(50% - ${width}px)`;
        }


        if (ntsPremium > 0){

            const buttonRewind = document.createElement("li");
            buttonRewind.classList.add("buttonrewind");

            const imgRewind = document.createElement("img");
            // imgRewind.dataset["src"] = domainurl + "css/svgs/rewind.svg";
            // imgRewind.classList.add("lazy-image");
            imgRewind.src = domainurl + "css/svgs/rewind.svg";
            imgRewind.alt = "rewind";
            imgRewind.width = 12;
            imgRewind.height = 12;

            buttonRewind.appendChild(imgRewind);

            buttonRewind.addEventListener("click", (e: Event) => {
                if (this._handleClickPremium)
                    this._handleClickPremium();
            });

            ulFirstDay?.insertAdjacentElement("afterbegin", buttonRewind);
        }

    }

    /**
     * Establece el manejador que inicia la animación al hacer click sobre el menú play de la animación con precarga
     *
     * @param handler Función manejadora
     */
    bindHandleStartMovieAnimation(handler: (loopSteps: number) => any){
        this._handleStartMovieAnimation = handler;
    }

    /**
     * Establece el manejador que detiene la animación al hacer click sobre el menú Stop de la animación con precarga
     *
     * @param handler Función manejadora
     */
    bindHandleStopMovieAnimation(handler: () => any){
        this._handleStopMovieAnimation = handler;
    }

    /**
     * Establece el manejador que cambia a un mapa del "futuro"
     *
     * @param handler Función manejadora
     */
    bindHandleSelectFutureOverlay(handler: () => any){
        this._handleSelectFutureOverlay = handler;
    }

    bindHandleGetFutureTranslation(handler: () => any){
        this._handleGetFutureTranslation = handler;
    }


    /**
     * Habilita la barra de precargar
     */
    enablePreloadedPlayBar(){
        if(this.slider)
            this.slider.classList.add("movieplaying");
        // if (this.buttonPlay)
        //     this.buttonPlay.classList.add("disabled");
    }

    /**
     * Deshabilita la barra de precargar
     */
    disablePreloadedPlayBar(){
        if(this.slider)
            this.slider.classList.remove("movieplaying");
        // if (this.buttonPlay)
        //     this.buttonPlay.classList.remove("disabled");
    }

}


export default RadarTimeSliderView;
